export default "__VITE_ASSET__20$2Qu3L__"